// Iter-207p — Unified "Invoicing audit" tabbed wrapper.
// Hosts the 3 read-only audit dashboards previously scattered in Finance ▸
// Facturation clients (Missed invoices · CRA scope audit · CRA Drive health)
// as Tabs so the CEO can navigate them in one place instead of 3.
import React, { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import MissedInvoicesAudit from "./MissedInvoicesAudit";
import CRAScopeAudit from "./CRAScopeAudit";
import CRADriveHealthCheck from "./CRADriveHealthCheck";
import { AlertTriangle, FileText, HardDrive } from "lucide-react";

export default function InvoicingAuditHub() {
  const [tab, setTab] = useState("missed");
  return (
    <div className="p-6 max-w-7xl mx-auto" data-testid="invoicing-audit-hub-page">
      <header className="mb-5 space-y-1">
        <h1 className="text-2xl font-light tracking-tight">Invoicing audit</h1>
        <p className="text-sm text-zinc-600 max-w-3xl leading-relaxed">
          Vue consolidée des 3 audits liés à la facturation client : factures oubliées, périmètre CRA, et conformité Drive des CRA générés.
        </p>
      </header>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="mb-4">
          <TabsTrigger value="missed" data-testid="invoicing-audit-tab-missed" className="flex items-center gap-2">
            <AlertTriangle size={14} /> Factures oubliées
          </TabsTrigger>
          <TabsTrigger value="scope" data-testid="invoicing-audit-tab-scope" className="flex items-center gap-2">
            <FileText size={14} /> Périmètre CRA
          </TabsTrigger>
          <TabsTrigger value="drive" data-testid="invoicing-audit-tab-drive" className="flex items-center gap-2">
            <HardDrive size={14} /> CRA Drive health
          </TabsTrigger>
        </TabsList>
        <TabsContent value="missed" className="mt-0">
          {/* Render the child pages directly. They each ship their own
              header + padding, but it's cosmetically OK : the Tabs container
              already lives at the top. */}
          <div className="-mx-6 -mb-6"><MissedInvoicesAudit /></div>
        </TabsContent>
        <TabsContent value="scope" className="mt-0">
          <div className="-mx-6 -mb-6"><CRAScopeAudit /></div>
        </TabsContent>
        <TabsContent value="drive" className="mt-0">
          <div className="-mx-6 -mb-6"><CRADriveHealthCheck /></div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
